var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_1663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.538635H24V16.3358H0V0.538635Z",
    fill: "#11457E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 8.43719V16.3358H0L10.0868 8.43719H24Z",
    fill: "#D7141A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0.538635V8.43721H10.0868L0 0.538635H24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_1663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15.7975,
    fill: "white",
    transform: "translate(0 0.538452)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCz);
export default __webpack_public_path__ + "static/media/CZ.eaa635e7899d96b562849c8742a1de03.svg";
export { ForwardRef as ReactComponent };